export const textFieldsRegexp = new RegExp('^[A-ZА-Яa-zа-яёЁ0-9 -_]*[A-ZА-Яa-zа-яёЁ0-9][A-ZА-Яa-zа-яёЁ0-9 -_]*$');

export const nutritionPlanValidator = (values: Record<string, any>): Record<string, string> => {
  const errors: Record<string, string> = {};

  const stringFields = ['title', 'description'];

  stringFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = 'Field is required';
      return;
    }
  });

  return errors;
};
